import { Category } from './Category';
import { Hero } from './Hero';
import { ShopBlocks } from '../../components/ShopBlocks';
import Accordion from '../../components/Accordion';
import Carousel from '../../components/Carousel';
import Feature from '../../components/HomepageFeature';
import FeaturedCollections from '../../components/FeaturedCollections';
import MissionStatement from './MissionStatement';
export var COMPONENTS = {
  ACCORDION: Accordion,
  CATEGORY: Category,
  CAROUSEL_CUSTOM: Carousel,
  CAROUSEL_PRODUCT: Carousel,
  CAROUSEL_UGC: Carousel,
  COLLECTIONS: FeaturedCollections,
  FEATURE: Feature,
  HERO: Hero,
  MISSION: MissionStatement,
  SHOP: ShopBlocks
};